export function* toggleAskBennieModalWatcher() {
  // NOTE: Previously we used react-router navigation state to persist visibility.
  // That causes a full route update on open/close, which makes the whole screen re-render.
  // Visibility is now handled purely in the Redux `modal` slice.
}

export function* toggleAskBennieAiModalWatcher() {
  // NOTE: Previously we used react-router navigation state to persist visibility.
  // That causes a full route update on open/close, which makes the whole screen re-render.
  // Visibility is now handled purely in the Redux `modal` slice.
}
